// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".save-btn-container[data-v-47e06f22]{margin-right:-.75em}", "",{"version":3,"sources":["webpack://./resources/client/modules/settings/components/TaskNextContactAt.vue"],"names":[],"mappings":"AACA,qCACE,mBAAF","sourcesContent":["\n.save-btn-container {\n  margin-right: -.75em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
